import React from 'react';

import { money as moneyFormat } from 'utils/format/money';
import policy_invoice_statuses from 'data/policy_invoice_statuses';
import Actions from './Actions';

const statusHuman = (value) => policy_invoice_statuses.find((item) => item.value == value).label;

const columns = (adminView) => [
  {
    name: 'Date',
    selector: (row) => row.attributes.invoice_date_formatted,
    sortable: true,
  },
  {
    name: 'Due Date',
    selector: (row) => row.attributes.due_date_formatted,
    sortable: true,
  },
  {
    name: 'Days Late',
    selector: (row) => row.attributes.days_late,
    sortable: true,
  },
  {
    name: 'Invoice Number',
    selector: (row) => row.attributes.invoice_number,
    sortable: true,
    cell: (row) => row.attributes.invoice_number,
  },
  {
    name: 'Payment Method',
    selector: (row) => row.attributes.payment_method,
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => row.attributes.status,
    sortable: true,
    cell: (row) => statusHuman(row.attributes.status),
  },
  {
    name: 'Amount',
    selector: (row) => row.attributes.amount,
    sortable: true,
    cell: (row) => moneyFormat(row.attributes.amount, row.attributes.currency.title),
  },
  {
    name: 'Actions',
    sortable: false,
    width: '120px',
    cell: (row) => <Actions row={row} adminView={adminView} />,
  },
];

export default columns;
